import * as constants from './user-constants';
import checkStatus from '../../utils/checkStatus';
import docCookies from '../../utils/docCookie';
import { callApiJWT } from '../../api';

export function updateUserProps(payload) {
  return { type: constants.UPDATE_USER_PROP, payload };
}

export const editNotificationSettings = payload => dispatch => {
  dispatch({ type: constants.EDIT_NOTIFICATION_STARTING });
  return fetch('/proxy/settings/notifications', {
    method: 'put',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  .then(res => res.json())
  .then(response => {
    if (response.error) return dispatch({ type: constants.EDIT_NOTIFICATION_FAILED, payload: response.error });
    return dispatch({ type: constants.EDIT_NOTIFICATION_FINISHED, payload: response });
  })
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.EDIT_NOTIFICATION_FAILED });
  });
};

function deleteAllCookies() {
  // document.cookie.replace(
  //   /(?<=^|;).+?(?=\=|;|$)/g,
  //   name => location.hostname
  //   .split(/\.(?=[^\.]+\.)/)
  //   .reduceRight((acc, val, i, arr) => i ? arr[i] = `.${val}${acc}` : (arr[i] = '', arr), '')
  //   .map(domain => document.cookie = `${name}=;max-age=0;path=/;domain=${domain}`)
  // );
  // avoid using "lookbehind" regex as it breaks safari
  document.cookie.split(';').forEach(cookie => {
    const cookieName = cookie.trim().split('=')[0];
    const subdomains = location.hostname.split(/\.(?=[^\.]+\.)/);

    subdomains.reduceRight((acc, val, i, arr) => {
        if (i) {
            arr[i] = `.${val}${acc}`;
        } else {
            arr[i] = '';
        }
        return acc;
    }, '');

    subdomains.forEach(domain => {
        if (domain) {
            document.cookie = `${cookieName}=;max-age=0;path=/;domain=${domain}`;
        }
    });
  });
}

const logout = () => async (dispatch) => {
  const token = localStorage.getItem('jwt');
  if (docCookies.hasItem('isAnAdmin')) docCookies.removeItem('isAnAdmin', '/', `${window.location.host.split('.')[1]}.com`);
  localStorage.clear();
  deleteAllCookies();
  // logout the middleware
  const res = await fetch('/logout', {
    method: 'post',
    credentials: 'same-origin',
    body: JSON.stringify({}),
    headers: { 'Accept': 'text/html', 'Content-Type': 'application/json' },
  });
  // logout from the backend
  await fetch(`${process.env.REAL_API_URL || process.env.API_URL}/logout`, {
    method: 'post',
    credentials: 'same-origin',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });
  const res2 = await checkStatus(res);
  // remove the localStorage key from the new app
  window.location = `${process.env.NEW_SYSTEM_URL}?logout=true`;
  return dispatch({ type: constants.LOG_OUT, user: res2 });
};
module.exports.logout = logout;

export function clearStores(isForAdmin, authToken) {
  return {
    type: constants.CLEAR_STORES,
    payload: { isForAdmin, authToken },
  };
}

export function getUser(refresh) {
  return dispatch => {
    return callApiJWT('/users', 'get')
    .then(({ response: res }) => dispatch({ type: constants.GET_USER, user: res, refresh }))
    .catch((err) => {
      if (err.message === 'Unauthorized') {
        return dispatch(logout())
        .then(() => {
          window.location.reload();
        });
      }
    });
  };
}

export function planUpdate(plan) {
  return {
    type: constants.USER_STORE_PLAN_UPDATE,
    payload: plan,
  };
}

export function updateUpgradeSource(source) {
  return {
    type: constants.UPDATE_UPGRADE_SOURCE,
    payload: source,
  };
}

export function logUpgradeClick(source, type) {
  return dispatch => {
    return fetch('/proxy/logupgradeclick', {
      method: 'put',
      credentials: 'same-origin',
      body: JSON.stringify({ source, type }),
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
    .then(checkStatus)
    .then(res => res.json())
    .then(() => dispatch({ type: constants.LOG_UPGRADE_CLICK }))
    .catch(err => console.log('err in logupgradeclick', err));
  };
}

export function authReceived(cookieInfo) {
  return {
    type: constants.AUTH_RECEIVED,
    payload: cookieInfo,
  };
}

export function setMarketingReadinessForUser() {
  return {
    type: constants.SET_MARKET_READINESS_FOR_USER_STORE,
  };
}

export function onBoardingComplete() {
  return {
    type: constants.ONBOARDING_COMPLETE,
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/user/user-actions.js